module.exports = __webpack_public_path__ + "img/laptop.445c8a36.svg";